<template>
  <div>
    <roles-form
      :is-active.sync="isEditing"
      method="put"
      :role="editingRole"
      @changed="roleUpdated"
    />
    <roles-form :is-active.sync="isAdding" @changed="roleAdded" />
    <permissions-form
      :role="currentRole"
      @update:role="roleUpdated"
      :is-active.sync="isCurrentRole"
    />
    <data-table
      title="Roles"
      ref="table"
      :url="url"
      :headers="headers"
      :archive="false"
      item-key="id"
      searchable
    >
      <v-btn slot="action.icons" color="primary" @click="isAdding = true">
        Add New Role
        <v-icon class="ml-2" color="light-blue lighten-4"> mdi-account-money</v-icon>
      </v-btn>

      <template slot="item.actions" slot-scope="{ item }">
        <div class="d-flex">
          <v-btn small icon @click="updateRole(item)">
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn small icon @click="showPermissionsModal(item)">
            <v-icon>mdi-eye-outline</v-icon>
          </v-btn>
        </div>
      </template>
    </data-table>
  </div>
</template>
<script>
import RolesForm from "./form";
import PermissionsForm from "./permissions.vue";

export default {
  components: {
    RolesForm,
    PermissionsForm,
  },
  data() {
    return {
      isAdding: false,
      isEditing: false,
      isCurrentRole: false,
      role: {},
      editingRole: null,
      currentRole: null,
      url: "/api/v1/admin/roles",
      headers: {
        name: "Name",
        slug: "Slug",
        description: "Description",
        actions: "Actions",
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    roleAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    roleUpdated({ message }) {
      this.editingRole = null;
      this.currentRole = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateRole(role) {
      this.editingRole = Object.assign({}, role);
      this.isEditing = true;
    },
    showPermissionsModal(role) {
      this.currentRole = Object.assign({}, role);
      this.isCurrentRole = true;
    },
  },
};
</script>
